export const noItemImage = '/r2/img/blindItemImage.svg';
